import React from 'react';
import { X } from 'lucide-react';

const EditProposalModal = ({ editProposalForm, setEditProposalForm, onClose, onSave }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
        {/* Modal Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200 sticky top-0 bg-white z-10">
          <h2 className="text-2xl font-bold text-gray-900">Edit Proposal</h2>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-full transition-colors"
          >
            <X size={24} className="text-gray-500" />
          </button>
        </div>

        {/* Modal Body */}
        <div className="p-6 space-y-6">
          {/* Basic Information */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Project Title *</label>
              <input
                type="text"
                value={editProposalForm.title}
                onChange={(e) => setEditProposalForm({...editProposalForm, title: e.target.value})}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="Enter project title"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Proposed Amount *</label>
              <input
                type="text"
                value={editProposalForm.proposedAmount}
                onChange={(e) => setEditProposalForm({...editProposalForm, proposedAmount: e.target.value})}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="e.g., R 15 000"
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Estimated Duration</label>
            <input
              type="text"
              value={editProposalForm.estimatedDuration}
              onChange={(e) => setEditProposalForm({...editProposalForm, estimatedDuration: e.target.value})}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              placeholder="e.g., 2-3 weeks"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Project Description</label>
            <textarea
              value={editProposalForm.description}
              onChange={(e) => setEditProposalForm({...editProposalForm, description: e.target.value})}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              rows="4"
              placeholder="Describe the project details..."
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Work Scope (one item per line)</label>
            <textarea
              value={editProposalForm.workScope.join('\n')}
              onChange={(e) => setEditProposalForm({...editProposalForm, workScope: e.target.value.split('\n').filter(item => item.trim())})}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              rows="4"
              placeholder="List work scope items...\nEach item on a new line"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Materials & Equipment (one item per line)</label>
            <textarea
              value={editProposalForm.materials.join('\n')}
              onChange={(e) => setEditProposalForm({...editProposalForm, materials: e.target.value.split('\n').filter(item => item.trim())})}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              rows="4"
              placeholder="List materials and equipment...\nEach item on a new line"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Additional Notes</label>
            <textarea
              value={editProposalForm.notes}
              onChange={(e) => setEditProposalForm({...editProposalForm, notes: e.target.value})}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              rows="3"
              placeholder="Any additional notes or special considerations..."
            />
          </div>
        </div>

        {/* Modal Footer */}
        <div className="flex justify-end gap-3 p-6 border-t border-gray-200">
          <button
            onClick={onClose}
            className="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={onSave}
            className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            Save Changes
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditProposalModal;
